import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Divider as RaisinDivider } from '@raisin/components-lib';

export const Divider = styled(RaisinDivider)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  margin: theme.spacing(4, 0),
  gap: theme.spacing(6),
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    padding: 0,
    margin: 0,
    gap: 0,
  },
}));

export const TableContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
  },
}));
